import React from 'react'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { useStore } from 'hooks'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import { AuthStore } from 'stores/auth'
import LoadingButton from 'components/LoadingButton'

const SigninSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').required('This field is required')
})

const SigninForm = () => {
  const router = useRouter()
  const authStore = useStore(AuthStore)

  if (authStore.loggedIn) {
    router.replace('/')
    return null
  }
  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true)
    try {
      const response = await authStore.emailCheck(values.email)
      if (response.doesExist) {
        router.push('/account/login')
      } else {
        router.push('/account/signup')
      }
    } catch (error) {
      actions.setSubmitting(false)
      actions.setStatus({ message: error.message })
    }
  }
  return (
    <Formik
      initialValues={{ email: '' }}
      validationSchema={SigninSchema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={handleSubmit}
      render={({ status, isSubmitting }) => (
        <Form noValidate className='commonForm'>
          {status && status.message && <div className='form__error'>{status.message}</div>}
          <Field type='email' name='email' placeholder='Email' />
          <ErrorMessage className='field__error' name='email' component='div' />
          <LoadingButton className='btn' loading={isSubmitting}>
            Continue
          </LoadingButton>
        </Form>
      )}
    />
  )
}

export default observer(SigninForm)
